import * as React from "react";
import styled from "react-emotion";
import ScrollNotifier from "../ScrollNotifier";
import { theme, mqMin } from "../../styles/theme";
import { getText } from "../../utilities";

const Wrap = styled.div`
  max-width: 32rem;
  margin-bottom: ${theme.space3};
  margin-left: auto;
  margin-right: auto;
  p {
    font-size: ${theme.h4};
    padding-bottom: ${theme.space2};
  }
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h3};
    p {
      font-size: ${theme.h4};
    }
  }
`;
const ArticleText = ({ slice }) => {
  console.log(slice);
  return (
    <div>
      <ScrollNotifier onEnter="DIAGONAL_RIGHT" />
      <Wrap
        dangerouslySetInnerHTML={{
          __html: slice.primary.text.html
        }}
      />
    </div>
  );
};

export default ArticleText;



// WEBPACK FOOTER //
// ./src/components/ArticleText/index.js